import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { HottestEvents } from "./components/HottestEvents";
import { ClientsCarousel } from "./components/ClientsCarousel";
import { Testimonials } from "./components/Testimonials";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { UpcomingEvents } from "./components/UpcomingEvents";
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
import { Toaster } from './components/ui/toaster';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <HottestEvents />
      <Services />
      <ClientsCarousel />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

const AboutPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <About />
      <Footer />
    </div>
  );
};

const UpcomingEventsPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <UpcomingEvents />
      <Footer />
    </div>
  );
};

const PrivacyPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation /> {/* Added Navigation to PrivacyPage */}
      <PrivacyPolicy onBack={() => window.history.back()} />
      <Footer /> {/* Added Footer to PrivacyPage */}
    </div>
  );
};

const TermsPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation /> {/* Added Navigation to TermsPage */}
      <TermsOfService onBack={() => window.history.back()} />
      <Footer /> {/* Added Footer to TermsPage */}
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/upcoming-events" element={<UpcomingEventsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;